export function hasClientSession() {
  return Boolean(localStorage.getItem('client_token'))
}

export function getClientCachedData() {
  try {
    const storedClient = localStorage.getItem('client_data')
    if (!storedClient) return {}

    const parsedClient = JSON.parse(storedClient)
    return parsedClient && typeof parsedClient === 'object' && !Array.isArray(parsedClient)
      ? parsedClient
      : {}
  } catch {
    localStorage.removeItem('client_data')
    return {}
  }
}

export function clearClientSession() {
  localStorage.removeItem('client_token')
  localStorage.removeItem('client_data')
}
